module.exports = __webpack_public_path__ + "img/logo_white.0fe50447.svg";